// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 72016 ? "fc22d32c" : chunkId) + "." + {"49984":"a4f1ac280c39b6f0","51653":"897a0d3067692d47","53348":"a47f49226f1701d5","72016":"7418f537f4cd4b02"}[chunkId] + ".js";
};